/*
 * newsbot - forked from autobrr
 */

import { Link } from "@tanstack/react-router";

export const NotFound = () => {
  return (
    <div className="min-h-screen flex flex-col justify-center">
      <div className="flex justify-center">
        <span className="text-4xl sm:text-6xl font-bold text-gray-900 dark:text-white">
          newsbot
        </span>
      </div>
      <h1 className="text-3xl text-center font-bold text-gray-900 dark:text-gray-200 my-8 px-2">
        Oops, this page doesn't exist!
      </h1>
      <h2 className="text-2xl text-center font-bold text-gray-900 dark:text-gray-200 my-8 px-2">
        404 Page not found
      </h2>
      <h3 className="text-xl text-center text-gray-700 dark:text-gray-400 mb-8 px-2">
        Let's get you back on track.
      </h3>
      <div className="flex justify-center">
        <Link to="/">
          <button
            className="w-48 flex justify-center py-2 px-4 border border-transparent rounded-md shadow-xs text-sm font-medium text-white bg-blue-600 dark:bg-blue-600 hover:bg-blue-700 dark:hover:bg-blue-700 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-blue-500"
          >
            Back to Dashboard
          </button>
        </Link>
      </div>
    </div>
  );
};
